'use client';
import { Upload } from 'antd';
import { GlobalContext } from 'context';
import React, { useContext, useEffect, useRef } from 'react';
import { TbSquarePlus } from 'react-icons/tb';
import { AttachmentType, ThemeEnum } from 'types';
import { COLORS } from 'utilities';
import styles from '../newTicket.module.scss';
import { ExtendedUploadRef } from '../newTicket.type';
import { RestAPI, useRealTimeState } from 'scripts';
import { API } from 'data';
import { UploadFile } from 'antd/lib';

function CustomUploaderComp({ onChange }: { onChange?: (e: number[]) => void }) {
    const uploadRef = useRef<ExtendedUploadRef>(null);
    const { theme } = useContext(GlobalContext);
    const fileLists = useRealTimeState<Array<UploadFile>>([]);
    const files = useRealTimeState<AttachmentType[]>([]);

    const handleButtonClick = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
        uploadRef.current?.upload?.uploader?.onClick(e);
    };

    useEffect(() => {
        onChange?.(files.get().map((i) => i.id));
    }, [files.dep]);

    const onUpload = (f: File) => {
        const list = [...fileLists.get()];
        const uid = `-${list.length + 1}`;
        list.push({
            uid,
            percent: 0,
            name: f.name,
            status: 'uploading',
        });
        fileLists.set(list);
        const body = new FormData();
        body.append('file', f);
        body.append('alt', f.name);
        RestAPI.form<AttachmentType>(API.core.attachment.index, body)
            .then((res) => {
                const newList = fileLists.get();
                const index = newList.findIndex((i) => i.uid === uid);
                if (index >= 0)
                    newList[index] = {
                        uid: res.data.id.toString(),
                        percent: 100,
                        name: f.name,
                        status: 'done',
                        url: res.data.file,
                    };
                files.set([...files.get(), res.data]);
                fileLists.set(newList);
            })
            .catch(() => {
                const newList = [...fileLists.get()];
                const index = newList.findIndex((i) => i.uid === uid);
                if (index >= 0)
                    newList[index] = {
                        uid: f.name,
                        name: f.name,
                        status: 'error',
                    };
                fileLists.set(newList);
            });
    };

    return (
        <div className={`${styles['upload-btn']} w-100`}>
            <div onClick={handleButtonClick} className="center-content-y flex-between w-100 pointer">
                <p className="t-p1 t-400 t-l-gray1">لطفا فایل خود را بارگذاری کنید</p>
                <TbSquarePlus size={16} color={theme === ThemeEnum.light ? COLORS.black1 : COLORS.gray3} />
            </div>
            <Upload
                ref={uploadRef}
                className={`${fileLists.dep.length ? styles['active'] : ''}`}
                fileList={fileLists.dep}
                showUploadList={{
                    showPreviewIcon: true,
                }}
                multiple={true}
                onPreview={(file: UploadFile) => window.open(file.url, '_blank')}
                customRequest={(e) => {
                    const temp: any = e;
                    const file: File = temp.file;
                    onUpload(file);
                }}
            />
        </div>
    );
}

export default CustomUploaderComp;
